import {useMutation, useQueryClient} from '@tanstack/react-query';
import contentSubmissionUpdaters from '@/api/updaters/contentSubmission';
import {CAMPAIGN_CONTENT_SUBMISSIONS_QUERY_KEY} from '@/hooks/queries/use-campaign-content-submissions-query';

export type TransitionAction = 'accept' | 'archive' | 'reject' | 'unarchive';

type TransitionParams = {
  action: TransitionAction;
  contentSubmissionId: string;
  campaignId: string;
  brandMessage?: string;
};

type UseContentSubmissionTransitionMutationParams = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

function useContentSubmissionTransitionMutation({
  onSuccess,
  onError,
}: UseContentSubmissionTransitionMutationParams = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      action,
      contentSubmissionId,
      brandMessage,
    }: TransitionParams) => {
      return contentSubmissionUpdaters[action]({
        contentSubmissionId,
        brandMessage,
      });
    },
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error: Error, {campaignId}) => {
      // invalidate all caches for this campaign so they refetch from the server.
      queryClient.invalidateQueries({
        queryKey: [CAMPAIGN_CONTENT_SUBMISSIONS_QUERY_KEY, campaignId],
      });
      onError?.(error);
    },
  });
}

export default useContentSubmissionTransitionMutation;
